import { render, staticRenderFns } from "./BriqBanner.vue?vue&type=template&id=5a07c85c&scoped=true&"
import script from "./BriqBanner.vue?vue&type=script&lang=js&"
export * from "./BriqBanner.vue?vue&type=script&lang=js&"
import style0 from "./BriqBanner.vue?vue&type=style&index=0&id=5a07c85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a07c85c",
  null
  
)

export default component.exports